import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const FooterSpan = styled.span`
    flex-direction: column;
    a{
      text-decoration: none;
      color: #333;
      transition: all 0.3s ease;
      border-radius: 2px;
      &:hover{
        border-radius: 12px;
        background-color: #333;
        padding:10px;
        color: aquamarine;
      }
    }
    display: flex;
    width: 100%;
    padding: 20px;
    margin: 2rem auto;
    text-align: center;
    justify-content: center;
    align-items: center;
`
const Footer = () => {
  return (
    <footer>
        <FooterSpan>
        @tibetism - 2022 
        <Link to="/admin">Admin Login</Link>
        </FooterSpan>
    </footer>
  )
}

export default Footer